import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { validate as ruleValidator } from '@tekion/tekion-base/utils/ruleValidator';
import FormEvent from '@tekion/tekion-base/utils/formEvent';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import actionTypes from './constants/actionTypes';
import eventTypes from './constants/eventTypes';
import formActionTypes from '../../organisms/FormBuilder/constants/actionTypes';
import { isErrorEmpty, getFormErrors } from '../../organisms/FormBuilder/utils/general';
var getOnSubmitEvent = function getOnSubmitEvent(contextId) {
  return "".concat(eventTypes.ON_SUBMIT, ":").concat(contextId);
};
export default function withEventSubmissionHOC(ComposedComponent) {
  var withEventSubmission = /*#__PURE__*/function (_PureComponent) {
    _inherits(withEventSubmission, _PureComponent);
    var _super = _createSuper(withEventSubmission);
    function withEventSubmission(_props) {
      var _this;
      _classCallCheck(this, withEventSubmission);
      _this = _super.call(this, _props);
      _defineProperty(_assertThisInitialized(_this), "handleErrors", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(errorPromiseByFieldId) {
          var _this$props, prevErrors, onAction, shouldRemoveErrorOnSubmission, errors;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, prevErrors = _this$props.errors, onAction = _this$props.onAction, shouldRemoveErrorOnSubmission = _this$props.shouldRemoveErrorOnSubmission;
                onAction({
                  type: formActionTypes.VALIDATION_IN_PROGRESS,
                  payload: {
                    errorPromiseByFieldId: errorPromiseByFieldId
                  }
                });
                _context.next = 4;
                return getFormErrors(errorPromiseByFieldId, shouldRemoveErrorOnSubmission ? EMPTY_OBJECT : prevErrors);
              case 4:
                errors = _context.sent;
                return _context.abrupt("return", errors);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "handleSubmit", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(additional) {
          var _assertThisInitialize, props, errorPromiseByFieldId, errors, _ref3, _ref4, actionType, payload;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _assertThisInitialize = _assertThisInitialized(_this), props = _assertThisInitialize.props;
                errorPromiseByFieldId = ruleValidator(props.values, props.values, _this.fieldRules);
                _context2.next = 4;
                return _this.handleErrors(errorPromiseByFieldId);
              case 4:
                errors = _context2.sent;
                _ref3 = isErrorEmpty(errors) ? [actionTypes.ON_FORM_SUBMIT, {
                  id: props.contextId,
                  additional: additional
                }] : [formActionTypes.VALIDATION_SUCCESS, {
                  errors: errors,
                  validationTriggeredOnSubmit: true,
                  additional: additional,
                  id: props.contextId
                }], _ref4 = _slicedToArray(_ref3, 2), actionType = _ref4[0], payload = _ref4[1];
                props.onAction({
                  type: actionType,
                  payload: payload
                });
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "handleAction", function (action) {
        var type = action.type,
          payload = action.payload;
        var _assertThisInitialize2 = _assertThisInitialized(_this),
          props = _assertThisInitialize2.props;
        if (type === formActionTypes.ON_RULE_CHANGE) {
          _this.fieldRules = payload.rules;
          // return;
        }

        props.onAction({
          type: type,
          payload: payload
        });
      });
      if (!_props.contextId) return _possibleConstructorReturn(_this);
      FormEvent.on(getOnSubmitEvent(_props.contextId), _this.handleSubmit);
      return _this;
    }
    _createClass(withEventSubmission, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var props = this.props;
        if (props.contextId) {
          props.onAction({
            type: formActionTypes.ADD_CONTEXT,
            payload: {
              id: props.contextId
            }
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var props = this.props;
        if (!props.contextId) return;
        FormEvent.removeListener(getOnSubmitEvent(props.contextId), this.handleSubmit);
        if (props.contextId) {
          props.onAction({
            type: formActionTypes.REMOVE_CONTEXT,
            payload: {
              id: props.contextId
            }
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;
        return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, props, {
          handleSubmit: this.handleSubmit,
          onAction: this.handleAction
        }));
      }
    }]);
    return withEventSubmission;
  }(PureComponent);
  withEventSubmission.propTypes = {
    contextId: PropTypes.string
  };
  withEventSubmission.defaultProps = {
    contextId: ''
  };
  return withEventSubmission;
}